<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<g id="Ellipse_183" data-name="Ellipse 183" fill="#d5f3ed" stroke="#d6ddea" stroke-width="1">
			<circle cx="10" cy="10" r="10" stroke="none" />
			<circle cx="10" cy="10" r="9.5" fill="none" />
		</g>
		<path
			id="Positive_Icon"
			data-name="Positive Icon"
			d="M2.554,4.552a.787.787,0,0,1-1.114,0L.23,3.343A.788.788,0,0,1,1.344,2.228L2,2.881,4.648.231A.788.788,0,1,1,5.761,1.345Z"
			transform="translate(7.098 7.192)"
			fill="#1bbc9c"
		/>
	</svg>
</template>

<script>
export default {
	name: 'SuccessViSVG',
};
</script>
